import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    d: 'M4.61891 11.6084C3.3568 11.0475 3.45938 9.22321 4.77642 8.8073L17.2491 4.86855C18.407 4.50291 19.4968 5.59275 19.1312 6.75063L15.1924 19.2233C14.7765 20.5404 12.9523 20.6429 12.3913 19.3808L11.1112 16.5004C10.8713 15.9607 10.8822 15.3425 11.1411 14.8116L12.9998 10.9999L9.15361 12.8516C8.62456 13.1063 8.01032 13.1157 7.47376 12.8772L4.61891 11.6084Z',
                    fill: '#82869E',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: true })) })));
};
const DirectionFilled = React.forwardRef(IconComponent);
DirectionFilled.displayName = 'DirectionFilled';

export { DirectionFilled };
